import axios from 'axios'
import qs from 'qs'
import errorParser from '@/utils/error-parser'
import Router from '../../router'

let request = (option) => {
  let newoption = { url: '/', method: 'get', params: {}};
  Object.assign(newoption, option);
  if (newoption.method === 'get') {
    newoption.url = newoption.url + '?' + qs.stringify(newoption.params);
  }
  Object.assign(newoption.params, {type: 2, app_id: '06bd61dd4e38b6bb', domain_type : 1 });
  newoption.params = qs.stringify(newoption.params);
  return new Promise((resolve, reject) => {
      axios[newoption.method](newoption.url, newoption.params).then(res => {
      resolve(res.data)
    }).catch((error) => {
      Router.push({ name: 'login' })
      reject(errorParser.parse(error))
    })
  })
}
export default request
